import { useEffect } from 'react';
import { useCity } from '../../contexts/CityContext';
import styles from './CitySelector.module.css';
import { MdDirections, MdAnnouncement } from 'react-icons/md';

const CitySelector = () => {
  const { cities, currentCity, setCurrentCity, showCitySelector, setShowCitySelector, isFirstVisit, setIsFirstVisit, loading } = useCity();

  // Modal dışı tıklamaları engelleme (ilk ziyaretse)
  useEffect(() => {
    const handleEsc = (event: KeyboardEvent) => {
      if (!isFirstVisit && event.key === 'Escape') {
        setShowCitySelector(false);
      }
    };

    window.addEventListener('keydown', handleEsc);
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isFirstVisit, setShowCitySelector]);

  if (!showCitySelector) {
    return null;
  }

  const handleCitySelect = (city: typeof cities[0]) => {
    setCurrentCity(city);
    setShowCitySelector(false);
    
    if (isFirstVisit) {
      setIsFirstVisit(false);
    }
  };

  const activeCities = cities.filter(city => city.isActive);
  const inactiveCities = cities.filter(city => !city.isActive);

  return (
    <div className={styles.modalOverlay} onClick={!isFirstVisit ? () => setShowCitySelector(false) : undefined}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.modalTitle}>Şehir Seçin</h2>
        <p className={styles.modalDescription}>
          Toplu taşıma bilgilerine erişmek istediğiniz şehri seçin
        </p>
        
        {loading ? (
          <div className={styles.loadingState}>
            <div className={styles.loadingSpinner}></div>
            <p>Şehirler yükleniyor...</p>
          </div>
        ) : (
          <>
            {activeCities.length > 0 && (
              <>
                <h3 className={styles.sectionTitle}>Aktif Şehirler</h3>
                <div className={styles.cityGrid}>
                  {activeCities.map((city) => (
                    <button
                      key={`${city.countryCode}-${city.cityCode}`}
                      className={`${styles.cityCard} ${currentCity?.cityCode === city.cityCode ? styles.activeCity : ''}`}
                      onClick={() => handleCitySelect(city)}
                    >
                      <div className={styles.cityName}>{city.cityName}</div>
                      <div className={styles.countryName}>{city.countryName}</div>
                      
                      {/* Şehir özellikleri ikonları */}
                      <div className={styles.cityFeatures}>
                        {city.routePlanning && (
                          <span className={styles.featureIcon} title="Yol Tarifi">
                            <MdDirections />
                          </span>
                        )}
                        {city.announcements && (
                          <span className={styles.featureIcon} title="Duyurular">
                            <MdAnnouncement />
                          </span>
                        )}
                      </div>
                    </button>
                  ))}
                </div>
              </>
            )}
            
            {inactiveCities.length > 0 && (
              <>
                <h3 className={styles.sectionTitle}>Yakında Gelecek</h3>
                <div className={styles.cityGrid}>
                  {inactiveCities.map((city) => (
                    <div
                      key={`${city.countryCode}-${city.cityCode}`}
                      className={`${styles.cityCard} ${styles.inactiveCity}`}
                    >
                      <div className={styles.cityName}>{city.cityName}</div>
                      <div className={styles.countryName}>{city.countryName}</div>
                      <div className={styles.comingSoon}>Yakında</div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </>
        )}
        
        {!isFirstVisit && (
          <button className={styles.closeButton} onClick={() => setShowCitySelector(false)}>
            Kapat
          </button>
        )}
      </div>
    </div>
  );
};

export default CitySelector;
